import { BaseDropdown, BaseInput, Ptag } from "components/core";
import React, { useMemo } from "react";
import { colors } from "theme";
import "./styles.css";
import { formatToIndianSystem } from "utlis/utils";

const GradeSumInsured = ({ formikProps, attribute, disabled }) => {
  let selectedDetails = localStorage.getItem("eb_selected_values");
  if (selectedDetails) {
    selectedDetails = JSON.parse(selectedDetails);
  }

  const isFlex = useMemo(() => {
    return selectedDetails?.flex;
  }, [selectedDetails]);

  const doesRangeExist = useMemo(() => {
    return attribute?.selectable_values?.length > 0;
  }, [attribute]);

  // const sumInsuredOptions = useMemo(() => {
  //   console.log("GradeSumInsured - sumInsuredOptions:", {
  //     attribute,
  //     selectable_values: attribute?.selectable_values,
  //     options: attribute?.selectable_values?.map((val) => ({
  //       label: formatToIndianSystem(val),
  //       value: val,
  //     }))
  //   });
  //   return attribute.selectable_values.map((val) => ({
  //     label: formatToIndianSystem(val),
  //     value: val,
  //   }));
  // }, [attribute]);

    const sumInsuredOptions = useMemo(() => {
    console.log("GradeSumInsured - sumInsuredOptions:", {
      attribute,
      selectable_values: attribute?.selectable_values,
      options: attribute?.selectable_values?.map((val) => ({
        label:
          !isNaN(val) && Number.isInteger(Number(val))
            ? formatToIndianSystem(val)
            : val,
        value: val,
      }))
    });
    return attribute?.selectable_values?.map((val) => ({
      label:
        !isNaN(val) && Number.isInteger(Number(val))
          ? formatToIndianSystem(val)
          : val,
      value: val,
    })) || [];
  }, [attribute]);

  return attribute ? (
    <>
      <Ptag
        color={colors.primaryColor}
        fontSize="18px"
        marginTop="1rem"
        marginBottom="10px"
        fontFamily="Montserrat"
      >
        Sum Insured
      </Ptag>
      <div className="sum-insured-container">
        {doesRangeExist ? (
          <BaseDropdown
            fontSize="16px"
            options={sumInsuredOptions}
            disabled={disabled}
            formikProps={{ ...formikProps, name: "sum_insured" }}
          />
        ) : (
          <BaseInput
            fontSize="16px !important"
            type="text"
            applyParseFloat={true}
            disabled={disabled}
            formatToIndianNumbering
            formikProps={{ ...formikProps, name: "sum_insured" }}
          />
        )}
        {doesRangeExist && isFlex && (
          <div className="sum-insured-container">
            {(() => {
              console.log("GradeSumInsured - Min field props:", {
                name: "sum_insured_min",
                value: formikProps.values?.sum_insured_min,
                options: sumInsuredOptions,
                errors: formikProps.errors?.sum_insured_min,
                touched: formikProps.touched?.sum_insured_min
              });
              return null;
            })()}
            <BaseDropdown
              fontSize="16px"
              label="Min"
              disabled={disabled}
              options={sumInsuredOptions}
              formikProps={{ 
                ...formikProps, 
                name: "sum_insured_min",
                errors: {
                  "sum_insured_min": formikProps.errors?.sum_insured_min
                },
                touched: {
                  "sum_insured_min": formikProps.touched?.sum_insured_min
                }
              }}
            />
            {(() => {
              console.log("GradeSumInsured - Max field props:", {
                name: "sum_insured_max",
                value: formikProps.values?.sum_insured_max,
                options: sumInsuredOptions,
                errors: formikProps.errors?.sum_insured_max,
                touched: formikProps.touched?.sum_insured_max
              });
              return null;
            })()}
            <BaseDropdown
              fontSize="16px"
              label="Max"
              disabled={disabled}
              options={sumInsuredOptions}
              formikProps={{ 
                ...formikProps, 
                name: "sum_insured_max",
                errors: {
                  "sum_insured_max": formikProps.errors?.sum_insured_max
                },
                touched: {
                  "sum_insured_max": formikProps.touched?.sum_insured_max
                }
              }}
            />
          </div>
        )}
      </div>
    </>
  ) : null;
};

export default GradeSumInsured;
